import request from '@/utils/request'

export function submitRedeemCode(code) {
  return request.post('/redeem/submit', { code })
}

export function getRedeemHistory() {
  return request.get('/redeem/history')
}
